import { render } from "./TableCommrecord.vue?vue&type=template&id=cb87ea78&scoped=true"
import script from "./TableCommrecord.vue?vue&type=script&lang=js"
export * from "./TableCommrecord.vue?vue&type=script&lang=js"

import "./TableCommrecord.vue?vue&type=style&index=0&id=cb87ea78&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb87ea78"]])

export default __exports__